import {ClassifiedFailedTable} from '../../Failed-list-table/ClassifiedFailedTable'
import {useListFailedView} from '../../core/ListFailedProvider'

export const FailedRecords = () => {
  const {data} = useListFailedView()
  const hasInvalid = Array.isArray(data.invalidBusiness) && data.invalidBusiness.length
  const hasExisting = Array.isArray(data.existingBusiness) && data.existingBusiness.length

  if (!hasInvalid && !hasExisting) {
    return null
  }

  return (
    <div className='pt-6'>
      {hasInvalid ? (
        <div className='mb-5'>
          <h2 className='fw-bolder text-center pb-2 border-bottom-1'>Invalid Format Records</h2>
          <ClassifiedFailedTable posts={data.invalidBusiness} />
        </div>
      ) : null}
      {hasExisting ? (
        <div className=''>
          <h2 className='fw-bolder text-center pb-2 border-bottom-1'>Existing Records</h2>
          <ClassifiedFailedTable posts={data.existingBusiness} />
        </div>
      ) : null}
    </div>
  )
}

